import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface IReleaseState {
	showPollingRelease: boolean;
	version: string | null;
}
const initialState: IReleaseState = {
	showPollingRelease: false,
	version: null,
};

interface ReleaseActions {
	setPollingRelease: (payload: boolean) => void;
	setVersion: (payload: string) => void;
}

// --- Store ---
export const useReleaseStore = create<IReleaseState & ReleaseActions>()(
	devtools(
		persist(
			(set) => ({
				...initialState,

				setPollingRelease: (payload) =>
					set(() => ({ showPollingRelease: payload })),
				setVersion: (payload) => set(() => ({ version: payload })),
			}),
			{
				name: 'release-store',
			},
		),
		{ name: 'ReleaseStore' },
	),
);
